import {cajeroStore} from "@/store/cajeroStore";
import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {Funcionario} from "@/models/Funcionario";
import {Cajero} from "@/models/Cajero";

export class CajeroService {
    private static instance: CajeroService;
    public static getInstance(): CajeroService {
        return this.instance || (this.instance = new this());
    }

    cajeroStore = cajeroStore();
    public async index(){
        this.cajeroStore.loading = true;
        await http.get("cajeros").subscribe({
            next: (response) => {
                this.cajeroStore.cajeros = response.data;
                this.cajeroStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.cajeroStore.loading = false;
            }
        })
    }

    public async store(cajero: Cajero){
        await http.post('cajeros', cajero).subscribe({
            next: (response) => {
                Alert.success(response.data.message);
                this.index();
                this.cajeroStore.showDialog = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
            }
        })
    }

    public async update(cajero: Cajero){
        await http.put(`cajeros/${cajero.id}`, cajero).subscribe({
            next: (response) => {
                Alert.success(response.data.message);
                this.index();
                this.cajeroStore.showDialog = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
            }
        })
    }

    public async destroy(id: number){
        await http.delete("cajeros/" + id).subscribe({
            next: (response) => {
                Alert.success(response.data.message);
                this.index();
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.index();
            }
        })
    }

    public async getFuncionarios(){
        await http.get("funcionarios").subscribe({
            next: (response) => {
                this.cajeroStore.usuarios = response.data;
                Alert.successTotastr("Lista de funcionarios actualizado");
            }
        });
    }

    public async storeFuncionario(funcionario: Funcionario){
        await http.post('funcionarios', funcionario).subscribe({
            next: (response) => {
                Alert.success(response.data.message);
                this.getFuncionarios();
                this.cajeroStore.showDialogFuncionario = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
            }
        })
    }
}